const header = [
	{
		'name': "سلعة",
		'id': 0,
		'isActive': false
	},
	{
		'name': "تفاصيل",
		'id': 1,
		'isActive': false
	},
	{
		'name': "تقييم",
		'id': 2,
		'isActive': false
	}
];

const evaluation = [
	{
		'name': 'الجميع',
		'id': 1,
		'isActive': false,
		'value': 'total',
		'grade': 0
	},
	{
		'name': 'مديح',
		'id': 2,
		'isActive': false,
		'value': 'good',
		'grade': 1
	},
	{
		'name': 'متوسط',
		'id': 3,
		'isActive': false,
		'value': 'medium',
		'grade': 2
	},
	{
		'name': 'تقييم سيء',
		'id': 4,
		'isActive': false,
		'value': 'bad',
		'grade': 3
	}
];
export {
	header,
	evaluation
}
